<!-- Vue component -->
<template>
    <div>
        <multiselect
                aria-required="true"
        v-model="value"
        :options="options"
        :placeholder="placeholder"
        multiple="multiple"
        track-by="name"
        label="name"
        @select="reload"
        @remove="reload">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from '../../lib/vue-multiselect/';


export default {
    components: { Multiselect },
    props: {
        options: Array,
        placeholder: String,
        selecteddata: Array,
        multiple: Boolean,
        inputname: String,
    },
    data() {
        return {
            value: this.selecteddata,
        }
    },
    methods: {
        reload(selectedOption) {
            window.location.href = selectedOption.url;
        },
    }
}
</script>

<style>
</style>
